export class AfterTaxCapitalizationRate {
  constructor({
    riskFreeRate = 0,
    equityRiskPremium = 0,
    sizePremium = 0,
    industryRisk = 0,
    countryRisk = 0,
    riskPremiumCompanySpecificRisks = 0,
    riskFreeRateNote = "",
    equityRiskPremiumNote = "",
    sizePremiumNote = "",
    industryRiskNote = "",
    countryRiskNote = "",
    riskPremiumCompanySpecificRisksNote = "",
  }) {
    this.riskFreeRate = riskFreeRate
    this.equityRiskPremium = equityRiskPremium
    this.sizePremium = sizePremium
    this.industryRisk = industryRisk
    this.countryRisk = countryRisk
    this.riskPremiumCompanySpecificRisks = riskPremiumCompanySpecificRisks
    this.riskFreeRateNote = riskFreeRateNote
    this.equityRiskPremiumNote = equityRiskPremiumNote
    this.sizePremiumNote = sizePremiumNote
    this.industryRiskNote = industryRiskNote
    this.countryRiskNote = countryRiskNote
    this.riskPremiumCompanySpecificRisksNote = riskPremiumCompanySpecificRisksNote
  }

  get afterTaxNetCashFlowDiscountRate() {
    return (
      this.riskFreeRate
      + this.equityRiskPremium
      + this.sizePremium
      + this.industryRisk
      + this.countryRisk
      + this.riskPremiumCompanySpecificRisks
    )
  }

  get longTermSustainableGrowthRate() {
    return (
      this.riskFreeRate
    )
  }

  get afterTaxNetCashFlowCapitalizationRate() {
    return this.afterTaxNetCashFlowDiscountRate - this.longTermSustainableGrowthRate
  }
}

export class PreTaxCapitalizationRate {
  constructor({
    afterTaxFreeCashFlow = 0,
    preTaxFreeCashFlow = 0,
    afterTaxNetCashFlowCapitalizationRate = 0,
    longTermSustainableGrowthRate = 0,
  }) {
    this.afterTaxFreeCashFlow = afterTaxFreeCashFlow
    this.preTaxFreeCashFlow = preTaxFreeCashFlow
    this.afterTaxNetCashFlowCapitalizationRate = afterTaxNetCashFlowCapitalizationRate
    this.longTermSustainableGrowthRate = longTermSustainableGrowthRate
  }

  get ratioAfterToPreTax() {
    if (this.preTaxFreeCashFlow === 0) return 0

    return (this.afterTaxFreeCashFlow / this.preTaxFreeCashFlow) * 100
  }

  get preTaxNetCashFlowCapitalizationRate() {
    if (this.ratioAfterToPreTax === 0) return 0

    return (this.afterTaxNetCashFlowCapitalizationRate / this.ratioAfterToPreTax) * 100
  }

  get preTaxNetCashFlowDiscountRate() {
    return this.preTaxNetCashFlowCapitalizationRate + this.longTermSustainableGrowthRate
  }
}



export default class CapitalizationRate {
  /**
   *
   * @param {AfterTaxCapitalizationRate} afterTaxCapitalizationRate
   * @param {PreTaxCapitalizationRate} preTaxCapitalizationRate
   * @param {String} analystNote
   */
  constructor({
    afterTaxCapitalizationRate,
    preTaxCapitalizationRate,
    analystNote = ""
  }) {
    this.afterTaxCapitalizationRate = afterTaxCapitalizationRate
    this.preTaxCapitalizationRate = preTaxCapitalizationRate
    this.analystNote = analystNote
  }
}